import React, {Component} from 'react';
import ViewRenderer from './views';
import {API} from '../../../requests';
import 'react-datasheet/lib/react-datasheet.css';
import './styles.css';
import PopupContainer from '../../../components/PopupContainer';
import POPUP_CONSTANTS from '../../../constants/popup-constants';
import Spinner from '../../../components/Spinner';
import Popup from '../../../components/SimplePopup';
import strings from '../../../globalization';
import util from '../../../util';
import {getFormData} from './data';
import DeletePopup from '../../../components/DeletePopup';
import {editFormData} from './editData';
import PopupData from '../../../components/PopupPerson/popup';
import {operatorImages} from '../../../assets/images';

class VehicleCategory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: undefined,

      searchText: '',
      vehicleCategoryType: [],
      filterVehicleCategoryType: [],
      selectedStatus: '',
    };
  }
  statuses = [
    {
      id: '',
      name: 'ALL',
    },
    {
      id: 'inactive',
      name: 'INACTIVE',
    },
    {
      id: 'active',
      name: 'ACTIVE',
    },
  ];
  updatedStatus = this.statuses.filter(elem => elem.id !== '');
  onSubmit = vehicleCategoryType => {
    const vehicleCategoryTypeData = {
      name: vehicleCategoryType.name.value,
      name_hindi: vehicleCategoryType.name_hindi.value,
    };

    this.saveVehicleCategoryType({
      ...vehicleCategoryTypeData,
    });
    this.setState({
      popup: null,
    });
  };
  showErrorPopup = errorMsg => {
    // crashlytics().recordError(new Error(errorMsg));

    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: errorMsg,
        messageStyle: {color: '#E67717'},

        buttons: [
          {
            text: strings.okayPopup,
            onClick: this.onClose,
          },
        ],
        onClose: this.closePopup,
      },
    });
  };
  showSuccessPopup = (successMessage, onClick) => {
    this.setState({
      popup: {
        type: POPUP_CONSTANTS.SIMPLE_POPUP,
        message: successMessage,
        onClose: this.onClose,
        headingImage: operatorImages.successIcon,
        buttons: [
          {
            text: strings.okayPopup,
            onClick: onClick ? onClick : this.onClose,
            outline: true,
          },
        ],
      },
    });
  };

  onClickHandler = (action, data) => {
    switch (action) {
      case 'edit': {
        this.setState({
          popup: {
            type: POPUP_CONSTANTS.EDIT_POPUP,
            statuses: this.updatedStatus,
            categoryTypeData: data,
          },
        });

        break;
      }
      case 'delete': {
        data.status === 'ACTIVE' &&
          this.setState({
            vehicleCategoryType: data,
            popup: {type: POPUP_CONSTANTS.DELETE_POPUP},
          });
        break;
      }
      default: {
        console.log('defalut chal rha');
        break;
      }
    }
  };
  onClose = () => {
    this.setState({
      popup: null,
    });
  };
  tableActionHandler = (action, data) => {
    switch (action) {
      case 'status': {
        this.setState(
          {
            selectedStatus: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'shift': {
        break;
      }
      case 'add': {
        this.setState({
          popup: {
            type: POPUP_CONSTANTS.ADD_DATA_POPUP,
          },
        });
        break;
      }

      case 'search': {
        this.setState(
          {
            searchText: data,
          },
          this.applyFilters,
        );
        break;
      }
      case 'clearFilter': {
        this.setState({
          searchText: '',
          selectedStatus: '',
        });
        this.fetchVehicleCategoryData();
        break;
      }
      default: {
        console.info('filterChangeHandler case not handled', action);
      }
    }
  };

  fetchVehicleCategoryData = () => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.fetchVehicleCategoryTableData()
      .then(res => {
        console.log('response', res);
        this.setState(
          {
            vehicleCategoryType: res.data,
            filterVehicleCategoryType: res.data,
            popup: null,
          },
          this.applyFilters,
        );
      })
      .catch(err => {
        const error = util.getErrorMessage(err);
        this.showErrorPopup(error);
      });
  };
  saveVehicleCategoryType = vehicleCategoryTypeName => {
    let formData = {
      name: vehicleCategoryTypeName.name,
      name_hindi: vehicleCategoryTypeName.name_hindi,
      status: vehicleCategoryTypeName.status,
    };
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.saveVehicleCategoryTypeData(formData)
      .then(res => {
        this.showSuccessPopup(
          'Vehicle Category Added Successfully',
          this.fetchVehicleCategoryData,
        );
      })
      .catch(error => {
        const errorMsg = util.getErrorMessage(error);
        this.showErrorPopup(errorMsg);
      });
  };
  deleteVehicleCategoryTypeData = id => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.deleteVehicleCategoryType(id)
      .then(res => {
        this.showSuccessPopup(
          'Vehicle Category Deleted Successfully',
          this.fetchVehicleCategoryData,
        );
      })
      .catch(error => {
        const err = util.getErrorMessage(error);
        this.showErrorPopup(err);
      });
  };
  updatesVehicleCategoryTypeData = data => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.updatesVehicleCategoryTypeData(data)
      .then(res => {
        this.showSuccessPopup(
          'Vehicle Category Updated Successfully',
          this.fetchVehicleCategoryData,
        );
      })
      .catch(error => {
        const errorMsg = util.getErrorMessage(error);
        this.showErrorPopup(errorMsg);
      });
  };
  onDeleteHandler = () => {
    let id = this.state.vehicleCategoryType.id;
    this.deleteVehicleCategoryTypeData(id);
    this.setState({popup: null});
  };
  getProps = () => {
    const {searchText, filterVehicleCategoryType, selectedStatus} = this.state;
    return {
      onClick: this.onClickHandler,
      onChange: this.onChangeHandler,
      filterChangeHandler: this.tableActionHandler,
      vehicleCategoryType: filterVehicleCategoryType,
      statuses: this.statuses,
      searchText,
      selectedStatus,
    };
  };
  onEditHandler = data => {
    let myData = {
      // id: this.state.vehicleCategoryType.id,
      id: data.id.value,
      name: data.name.value,
      name_hindi: data.name_hindi.value,
      status: data.status.value.toUpperCase(),
    };
    this.setState({popup: null});
    this.updateVehicleCategoryType(myData);
  };
  updateVehicleCategoryType = data => {
    this.setState({popup: {type: POPUP_CONSTANTS.SPINNER_POPUP}});
    API.updatesVehicleCategoryTypeData(data)
      .then(res => {
        this.showSuccessPopup(
          'Vehicle Category Updated Successfully',
          this.fetchVehicleCategoryData,
        );
      })
      .catch(error => {
        const errorMsg = util.getErrorMessage(error);
        this.showErrorPopup(errorMsg);
      });
  };
  applyFilters = () => {
    const {searchText, selectedStatus, vehicleCategoryType} = this.state;
    const filteredData =
      vehicleCategoryType.length > 0 &&
      vehicleCategoryType.filter(row => {
        if (
          searchText &&
          !Object.values({name: row.name, name_hindi: row.name_hindi})
            .toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        ) {
          return false;
        }

        if (
          selectedStatus &&
          row.status.toLowerCase() !== selectedStatus.toLowerCase()
        ) {
          return false;
        }
        return true;
      });
    this.setState({
      filterVehicleCategoryType: filteredData,
    });
  };
  getPopupContent = () => {
    const {popup} = this.state;
    switch (popup.type) {
      case POPUP_CONSTANTS.ADD_DATA_POPUP: {
        return (
          <PopupData
            header="Add"
            onSubmit={this.onSubmit}
            onClose={this.onClose}
            getFormData={getFormData}
            {...popup}
          />
        );
      }
      case POPUP_CONSTANTS.EDIT_POPUP: {
        return (
          <PopupData
            header="Edit"
            onSubmit={this.onEditHandler}
            onClose={this.onClose}
            getFormData={editFormData}
            {...popup}
          />
        );
      }
      case POPUP_CONSTANTS.DELETE_POPUP: {
        return (
          <DeletePopup onClick={this.onDeleteHandler} onClose={this.onClose} />
        );
      }
      case POPUP_CONSTANTS.SPINNER_POPUP: {
        return <Spinner name="cube-grid" color="#0045E6" {...popup} />;
      }
      case POPUP_CONSTANTS.SIMPLE_POPUP: {
        return <Popup {...popup} />;
      }
      default: {
        console.warn('getPopupContent', popup.type);
        return null;
      }
    }
  };
  componentDidMount() {
    this.fetchVehicleCategoryData();
  }

  render() {
    const viewProps = this.getProps();
    const {popup} = this.state;
    return (
      <>
        {popup ? (
          <PopupContainer> {this.getPopupContent()} </PopupContainer>
        ) : null}
        <ViewRenderer {...viewProps} />
      </>
    );
  }
}

export default VehicleCategory;
